<div class="list-group-item text-center">
  <div class="collapse show">
    <p>{{ parameterService.channel?.description }}</p>
    <p>{{ referenzText() }}: {{ parameterService.payment?.public_id }}</p>
  </div>
</div>
@if (parameterService.payment?.ordercontent?.items?.length ?? 0 > 0)
{
  <div class="list-group-item">
    <h6 class="text-center">Details</h6>
    @for (item of parameterService.payment?.ordercontent?.items; track item) {
      <div class="overview-wrapper">
        <span>
          {{ item.count }} x {{ item.name }}
          @if (item.eventrange) {
            <br />
            <small>{{ item.eventrange }}</small>
          }
        </span>
        <span>{{ item.count * item.amount | currency : 'EUR' : 'symbol' }}</span>
      </div>
    }
    <div class="overview-wrapper">
      <span><b>Gesamtbetrag</b></span>
      <span><b>{{parameterService.payment?.totalamount | currency : 'EUR' : 'symbol'}}</b></span>
    </div>
  </div>
}
